<!-- specijaliteti.html - NAŠI SPECIJALITETI Netflix Gallery -->
<section id="specijaliteti" class="netflix-gallery">
    <!-- Hero Statement -->
    <div class="gallery-hero">
      <div class="hero-content">
        <h2 class="hero-title">Naši specijaliteti</h2>
        <p class="hero-text">
          Od roštilja do slatkiša - majstorski pripremljeno sa ljubavlju. 
          Svaki zalogaj priča priču Kockice.
        </p>
      </div>
    </div>
    
    <!-- Netflix Horizontal Scroll Gallery -->
    <div class="netflix-carousel" #carousel>
      <div class="carousel-track" #carouselTrack>
        
        <!-- 1. Biftek -->
        <div class="netflix-card" style="--delay: 0.1s">
          <div class="card-image">
            <img src="biftek.jpeg" alt="Kockica biftek" loading="lazy">
            <div class="card-overlay">
              <h3>Steak</h3>
              <p>Odabrani juneći odrezak, pažljivo pripremljen prema tradicionalnom receptu.</p>
            </div>
          </div>
        </div>
  
        <!-- 2. Ćevapi -->
        <div class="netflix-card" style="--delay: 0.2s">
          <div class="card-image">
            <img src="cevapi.jpeg" alt="Kockica ćevapi" loading="lazy">
            <div class="card-overlay">
              <h3>Ćevapi</h3>
              <p>Autentično pripremljeni u dagari, posluženi sa svježim kajmakom.</p>
            </div>
          </div>
        </div>
  
        <!-- 3. Mješovita plata -->
        <div class="netflix-card" style="--delay: 0.4s">
          <div class="card-image">
            <img src="plata2.jpeg" alt="Kockica mješovita plata" loading="lazy">
            <div class="card-overlay">
              <h3>Kockica plata</h3>
              <p>Naša specijalna mješavina roštiljskih delicija, pripremljena za zajedničko uživanje.</p>
            </div>
          </div>
        </div>

        <div class="netflix-card" style="--delay: 0.3s">
            <div class="card-image">
              <img src="bosanska.jpeg" alt="Bosanska pizza" loading="lazy">
              <div class="card-overlay">
                <h3>Bosanska pizza</h3>
                <p>Naša domaća pizza sa svježim sastojcima.</p>
              </div>
            </div>
          </div>

        <div class="netflix-card" style="--delay: 0.6s">
            <div class="card-image">
              <img src="piletina.jpeg" alt="Kockica piletina" loading="lazy">
              <div class="card-overlay">
                <h3>Piletina</h3>
                <p>Hrskava piletina u susamu.</p>
              </div>
            </div>
          </div> 
  
        <!-- 5. Torta -->
        <div class="netflix-card" style="--delay: 0.5s">
          <div class="card-image">
            <img src="torta.jpeg" alt="Kockica torta" loading="lazy">
            <div class="card-overlay">
              <h3>Torte</h3>
              <p>Domaće torte — sočne, bogatog okusa i savršen kraj svakog obroka.</p>
            </div>
          </div>
        </div>

        <div class="netflix-card" style="--delay: 0.3s">
            <div class="card-image">
              <img src="dubai.jpeg" alt="Kockica palačinke" loading="lazy">
              <div class="card-overlay">
                <h3>Palačinke</h3>
                <p>Dubai palačinke — sočne, punjene pistacijama, pravi egzotični užitak.</p>
              </div>
            </div>
          </div>
      </div> 
    </div> 
  </section>
  